import {isDefined} from '@cypro/engine/utils'

export interface PrescriptionDoseFields {
  activeSubstanceId?: string | null
  calculationMethod?: string | null
  regularDose?: number | null
  doseProportion?: number | null
  precisionDecimals?: number | null
}

const patientValueCalculationMethods = new Set(['BSA', 'BSA30', 'WEIGHT', 'AUC'])

/** Reports whether the total amount depends on the patient's current weight, height, BSA or GFR. */
export function doseCalculationUsesPatientValues(calculationMethod?: string | null) {
  return calculationMethod != null && patientValueCalculationMethods.has(calculationMethod)
}

/**
 * Reports whether the form changed anything that decides the dose. A doctor-validated
 * prescription keeps its validated total until one of these fields changes.
 */
export function doseFieldsChanged(current: PrescriptionDoseFields, saved: PrescriptionDoseFields) {
  const changedActiveSubstance =
    isDefined(current.activeSubstanceId) &&
    isDefined(saved.activeSubstanceId) &&
    current.activeSubstanceId !== saved.activeSubstanceId

  return (
    changedActiveSubstance ||
    (current.calculationMethod ?? null) !== (saved.calculationMethod ?? null) ||
    (current.regularDose ?? 0) !== (saved.regularDose ?? 0) ||
    (current.doseProportion ?? 100) !== (saved.doseProportion ?? 100) ||
    (current.precisionDecimals ?? 2) !== (saved.precisionDecimals ?? 2)
  )
}
